@if(!hasChildren && item.path) {
    <a [routerLink]="[item.path]" routerLinkActive="active" [target]="(item.target) ? item.target : '_self'" [routerLinkActiveOptions]="{ exact: true }" [ngClass]="item.highlighted ? 'highlighted' : ''"
       class="d_flex item_nav y_items_center" (mouseenter)="showTooltip($event)" (mouseleave)="hideTooltip($event)">
        <span [class]="!item.image ? item.icon : ''">
            @if(item.image && !disableImage) {
                <img src="{{item.image}}" alt="Icon" width="24px;" />
            }
            <span [innerHTML]="item.label | translate | safeHtml"></span>
        </span>
    </a>
    <div class="tooltip_nav" [innerHTML]="item.label | translate | safeHtml"></div>
}
@if(hasChildren) {
    <div routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggle(item.path);sidenavService.open()"
         class="d_flex item_nav y_items_center has_child" [ngClass]="parentClasses" (mouseenter)="showTooltip($event)" (mouseleave)="hideTooltip($event)">
        <span [class]="!item.image ? item.icon : ''">
            @if(item.image) {
                <img src="{{item.image}}" alt="Icon" width="24px;" />
            }
            <span [innerHTML]="item.label | translate | safeHtml"></span>
        </span>
    </div>
    <div class="tooltip_nav" [innerHTML]="item.label | translate | safeHtml"></div>
    <div class="subnav">
        @for(child of item.children; track child) {
            <app-navigation-sidenav-item [item]="child" [disableImage]="true"></app-navigation-sidenav-item>
        }
    </div>
}
